import { ContentLibraryItem } from '@/components/contentLibrary/contentLibraryItem';

export default ContentLibraryItem;
